import React from 'react';
import './Home.scss';
// import Tree from '../tree/Tree';
import Campaign from '../campaign/Campaign';
import Parse from "parse";

class Home extends React.Component {
    constructor() {
        super();
        this.state = {
            buttonLoading: false,
            usernameError: false,
            passwordError: false,
            username: '',
            password: ''
        }
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    changeHandler = event => {
        const name = event.target.getAttribute('id');
        const value = event.target.value;
        if (!value || value === "") {            
            this.setState({
                [`${name}Error`]: true
            })
        } else { 
            this.setState({
                [`${name}Error`]: false,
                [name]: value
            })
        }
    }

    handleSubmit = async (event) => {
        event.preventDefault();
        try{
            await Parse.User.logIn(this.state.username, this.state.password);
            alert("Logged in!");
        } catch (e){
            alert(e.message); 
        }
        
    }

    render() {

        return (
            <div>
                <div className="branding"></div>
                {/* <Tree></Tree> */}
                <Campaign></Campaign>
                {/* <div className="foreground"></div> */}
            </div>
           
        );
    }
}

export default Home;
